/**
 * JSON:API base class providing `id` and `type` for resources.
 */
export class JsonapiEntity {
    id;
    type;
    constructor(properties = {}) {
        const { type, ...props } = properties;
        Object.assign(this, props);
        const proto = new.target.prototype;
        if (!this.type && proto && proto.type) {
            this.type = proto.type;
        }
        else if (!this.type && type) {
            this.type = type;
        }
    }
    static create(properties = {}) {
        return newEntity(this, properties);
    }
}
export function newEntity(entity, properties = {}) {
    return Object.assign(new entity(properties), properties);
}
